
import Highlight from '@/components/common/HighlightItem.vue'
import { defineComponent, PropType } from 'vue-demi'
import { theme } from '@/config/styles'

interface IPontosForte {
    title: string
    pontos: [
        {
            title: string
            description: string
            image: string
            altText: string
        }
    ]
}

/**
 * Componente para informações de destaque
 * @props {Object} pontosForte - Um objeto contendo todos os dados utilizado no
 * component
 * @interface IPontosForte - interface utilizada para o props pontosForte
 */
export default defineComponent({
    props: {
        pontosForte: Object as PropType<IPontosForte>,
    },
    components: {
        Highlight,
    },
    setup() {
        return {
            theme
        }
    }
})
